import styled, { css } from "styled-components"
import breakpoint from "styled-components-breakpoint"
import Arrow from "../arrow"
import { P } from "../typography"

export const Content = styled.p`
  margin: 0;
  color: ${(props) => props.theme.colors.body};
`

export const Text = styled.span`
  font-size: 0.8rem;
  color: ${(props) => props.theme.colors.notifications.meta};
`

export const Main = styled.div`
  flex: 1;
`

export const Side = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding-left: 2rem;
`

export const Top = styled.div`
  > :not(:last-child) {
    margin-bottom: 0.5rem;
  }
`

export const Bottom = styled.div`
  display: flex;
  justify-content: space-between;
`

const contentContainerStyles = css`
  width: 100%;
  height: 100%;
  padding: 2rem;
  display: flex;
  box-sizing: border-box;
  text-decoration: none;
  position: relative;
`

export const StyledLink = styled.a`
  ${contentContainerStyles}
`

export const Div = styled.div`
  ${contentContainerStyles}
`

export const Desktop = styled.div`
  display: none;

  &.slide-out {
    animation: slide-out 0.5s forwards;
  }

  @keyframes slide-out {
    0% {
      transform: translateX(0%);
    }
    100% {
      transform: translateX(-120%);
    }
  }

  ${breakpoint("tablet")`
    display: block;
  `}
`

export const Container = styled.div`
  &.slide-out {
    animation: slide-out 0.5s forwards;
  }

  @keyframes slide-out {
    0% {
      transform: translateX(0%);
    }
    100% {
      transform: translateX(-120%);
    }
  }
`

export const Mobile = styled.div`
  ${breakpoint("tablet")`
    display: none;
  `}
`

export const Hover = styled.div`
  cursor: pointer;
`

export const Obj = styled.object`
  right: 15px;
  display: block;
  color: ${(props) => props.theme.colors.body};
  font-size: 2rem;
  position: absolute;
  top: 5px;
  cursor: pointer;

  ${breakpoint("tablet")`
    right: 20px;
    top: 10px;
  `}
`

export const StyledArrow = styled(Arrow)`
  right: 15px;
  bottom: 15px;
  position: absolute;

  ${breakpoint("tablet")`
    right: 20px;
    bottom: 25px;
  `}
`

export const Meta = styled(P).attrs({
  marginless: true,
  size: "small"
})`
  color: ${({ theme }) => theme.colors.notifications?.meta || theme.colors.primary};
`
